<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage customers.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4"
     *ngIf="accountService.getMyAccount().can_manage_members && serverError === null">

  <h2>Add Credit or Voucher</h2>

  <p>
    This will add value to the <b>{{ customerIdCount }}</b>
    selected customers' accounts.
  </p>

  <div class="row">
    <div class="col-sm-8 col-md-6 col-xl-4">

      <div class="form-group mt-2">
        <label for="typeSelect">Type</label>
        <select class="form-control" id="typeSelect"
                [(ngModel)]="selectedType" required>
          <option value="{{ TYPE_CREDIT }}">{{ TYPE_CREDIT }}</option>
          <option value="{{ TYPE_VOUCHER }}">{{ TYPE_VOUCHER }}</option>
        </select>
      </div>

      <form *ngIf="selectedType === TYPE_CREDIT" (submit)="handleCreditSubmit()">

        <div class="form-group">
          <label for="amountInput">Value</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ organizationConfigService.getCurrencySymbol() }}</span>
            </div>
            <input id="amountInput" type="number" min="0.01" step="0.01"
                   class="form-control" name="amount" required
                   [(ngModel)]="credit.amount_total">
          </div>
          <div class="form-text text-danger">
            {{ creditErrors.amount_total }}
          </div>
        </div>

        <div class="form-group">
          <label for="creditExpiryDateInput">Expiry Date (Optional)</label>
          <app-date-picker [id]="'creditExpiryDateInput'"
                           [(content)]="credit.expiry_date"></app-date-picker>
          <div class="form-text text-danger">
            {{ creditErrors.expiry_date }}
          </div>
        </div>

        <div class="custom-control custom-checkbox mb-3">
          <input type="checkbox" class="custom-control-input"
                 id="will_apply_to_recurring_payments"
                 name="will_apply_to_recurring_payments"
                 [(ngModel)]="credit.will_apply_to_recurring_payments">
          <label class="custom-control-label" for="will_apply_to_recurring_payments">
            This credit will apply to recurring membership payments
          </label>
        </div>

        <div class="indented-subsection">
          <div class="custom-control custom-checkbox mb-3"
               *ngIf="credit.will_apply_to_recurring_payments">
            <input type="checkbox" class="custom-control-input"
                   id="only_applies_to_recurring_payments"
                   name="only_applies_to_recurring_payments"
                   [(ngModel)]="credit.only_applies_to_recurring_payments">
            <label class="custom-control-label" for="only_applies_to_recurring_payments">
              This credit may only apply to recurring membership payments
            </label>
            <small class="form-text text-muted">
              If enabled, this credit will only apply to automatic recurring payments. It cannot be used for the initial purchase of a recurring membership.
            </small>
          </div>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="creditErrors.non_field_errors">
          {{ creditErrors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="creditErrorMessage">
          {{ creditErrorMessage }}
        </div>

        <ng-container *ngIf="loadingCredit">
          <div class="alert alert-info" role="alert">
            Creating Credits...
          </div>

          <div class="progress">
            <div class="progress-bar" role="progressbar" [style]="{width: getProgressPercentageStr() + '%'}"
                 attr.aria-valuenow="{{ getProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </ng-container>

        <!-- Place save button first so that the enter key press activates it -->
        <div class="mt-4">
          <div class="float-right">
            <button type="submit" class="btn btn-primary"
                    [disabled]="loadingCredit" [class.disabled]="loadingCredit">
              Save
            </button>
          </div>
          <button routerLink="/customers"
                  [disabled]="loadingCredit" [class.disabled]="loadingCredit"
                  class="btn btn-secondary">
            Cancel
          </button>
        </div>

      </form>

      <form *ngIf="selectedType === TYPE_VOUCHER" (submit)="handleVoucherSubmit()">

        <div class="form-group">
          <label for="useVoucherEventType">Voucher Type</label>
          <select id="useVoucherEventType" name="useVoucherEventType"
                  class="custom-select"
                  [(ngModel)]="useVoucherEventType"
                  (ngModelChange)="clearVoucherEventTypeAndCategory()">
            <option [ngValue]="true">Event Type</option>
            <option [ngValue]="false">Event Category</option>
          </select>
        </div>

        <div class="form-group" *ngIf="useVoucherEventType">
          <label for="eventTypeSelect">Event Type</label>
          <select id="eventTypeSelect" name="eventType"
                  class="custom-select"
                  [(ngModel)]="voucher.event_type_id" *ngIf="!loadingEventTypes" required>
            <option [ngValue]="null" disabled>---</option>
            <option *ngFor="let eventType of eventTypeList"
                    [ngValue]="eventType.id">
              {{ eventType.name }}
              <ng-container *ngIf="eventType.status === EventTypeStatus.retired">(Retired)</ng-container>
            </option>
          </select>
          <select id="eventTypeSelectLoading" class="custom-select" name="eventType"
                  [(ngModel)]="voucher.event_type_id" *ngIf="loadingEventTypes" disabled>
            <option selected>Loading...</option>
          </select>
          <div class="form-text text-danger">
            {{ voucherErrors.event_type_id }}
          </div>
        </div>

        <div class="form-group" *ngIf="!useVoucherEventType">
          <label for="event_category_id">Event Category</label>
          <select id="event_category_id" name="event_category_id"
                  class="custom-select"
                  [(ngModel)]="voucher.event_category_id" *ngIf="!loadingEventCategories" required>
            <option [ngValue]="null" disabled>---</option>
            <option *ngFor="let eventCategory of eventCategoryList"
                    [ngValue]="eventCategory.id">
              {{ eventCategory.name }}
            </option>
          </select>
          <select id="eventCategorySelectLoading" class="custom-select" name="event_category_id"
                  [(ngModel)]="voucher.event_category_id" *ngIf="loadingEventCategories" disabled>
            <option selected>Loading...</option>
          </select>
          <div class="form-text text-danger">
            {{ voucherErrors.event_category_id }}
          </div>
        </div>

        <div class="form-group">
          <label for="numberInput">Number of Vouchers</label>
          <input id="numberInput" type="number" min="1" step="1"
                 class="form-control" name="amount" required
                 [(ngModel)]="voucher.number_of_uses_total">
          <div class="form-text text-danger">
            {{ voucherErrors.number_of_uses_total }}
          </div>
        </div>

        <div class="form-group">
          <label for="voucherExpiryDateInput">Expiry Date (Optional)</label>
          <app-date-picker [id]="'voucherExpiryDateInput'"
                           [(content)]="voucher.expiry_date"></app-date-picker>
          <div class="form-text text-danger">
            {{ voucherErrors.expiry_date }}
          </div>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="voucherErrors.non_field_errors">
          {{ voucherErrors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="voucherErrorMessage">
          {{ voucherErrorMessage }}
        </div>

        <ng-container *ngIf="loadingVoucher">
          <div class="alert alert-info" role="alert">
            Creating Vouchers...
          </div>

          <div class="progress">
            <div class="progress-bar" role="progressbar" [style]="{width: getProgressPercentageStr() + '%'}"
                 attr.aria-valuenow="{{ getProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </ng-container>

        <!-- Place save button first so that the enter key press activates it -->
        <div class="mt-4">
          <div class="float-right">
            <button type="submit" class="btn btn-primary"
                    [disabled]="loadingVoucher || loadingEventTypes"
                    [class.disabled]="loadingVoucher || loadingEventTypes">
              Save
            </button>
          </div>
          <button routerLink="/customers"
                  [disabled]="loadingVoucher || loadingEventTypes"
                  [class.disabled]="loadingVoucher || loadingEventTypes"
                  class="btn btn-secondary">
            Cancel
          </button>
        </div>

      </form>

    </div>
  </div>
</div>
